import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';
import { IngramAppLinks } from './ingramAppLinks';
import React from 'react';
import { AppQrCode } from './appQrCode';
import Typography from '@mui/material/Typography';
import { useTranslate } from '@im/react-localization';

export const SmallScreenLoginTopSection = () => {
  const translateStr = useTranslate();
  return (
    <Stack
      alignItems={'center'}
      display={'flex'}
      flexDirection={'column'}
      gap={'16px'}
      height={'376px'}
      justifyContent={'center'}
    >
      <Typography fontWeight={'500'}>
        {translateStr('Login.QR_code_header')}
      </Typography>
      <Stack
        display={'flex'}
        flexDirection={'row'}
        gap={'16px'}
        justifyContent={'center'}
      >
        <Grid
          columnGap={'12px'}
          display={'flex'}
          flexDirection={'column'}
          justifyContent={'space-between'}
        >
          <IngramAppLinks width="133px" />
        </Grid>
        <Stack alignItems={'center'} display={'flex'} rowGap={'16px'}>
          <AppQrCode size={92} />
        </Stack>
      </Stack>
    </Stack>
  );
};
